// « Support » = mêmes messages que « Contact » (GET /contact) : lecture
// seule, pas de ticket éditable côté backend.
import contactResource from "../contact";

export default contactResource;
